import { useCallback, useState } from 'react';

export const TOTAL_STEPS = 6;

export type Direction = 'forward' | 'back';

export function useStepFlow() {
  const [step, setStep] = useState(1);
  const [direction, setDirection] = useState<Direction>('forward');

  const next = useCallback(() => {
    setDirection('forward');
    setStep(s => Math.min(s + 1, TOTAL_STEPS));
  }, []);

  const back = useCallback(() => {
    setDirection('back');
    setStep(s => {
      if (s === 1) {
        // Signal to parent to go back to welcome page
        return 0;
      }
      return Math.max(s - 1, 1);
    });
  }, []);

  return { step, direction, next, back, isBackToWelcome: step === 0 };
}
